import "../scrap.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import addIcon from "../../../assets/svgs/add.svg";
import { useNavigate } from "react-router-dom";
import ImportExportCsv from "../../../components/ImportExportCsv/ImportExportCsv";
import { getScrapCategoriesApproved } from "../scraps-service";
import CardListScrapCategories from "./cardlist-scrap-categories/cardlist-scrap-categories";
import { useAuth } from "../../../contexts/auth-context";
import FilterComponent from "../../../components/FIlter/filter";
import { ScrapsCategoryInfoDTO } from "./models/scrap-category-DTO";

const ScrapCategories: React.FC<{ enabledUsers: string[] }> = ({ enabledUsers }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userDoc } = useAuth();
  const profile = userDoc?.profile;

  const [scrapCategories, setScrapCategories] = useState<ScrapsCategoryInfoDTO[]>([]);
  const [filteredData, setFilteredData] = useState<ScrapsCategoryInfoDTO[]>([]);

  const sortByRegion = (data: ScrapsCategoryInfoDTO[]) => {
    return [...data].sort((a, b) => {
      const nameA = a.name?.toString().toLowerCase() || '';
      const nameB = b.name?.toString().toLowerCase() || '';
      return nameA.localeCompare(nameB);
    });
  };
 

  const sortOptions = [
    { label: t("label-material"), sortFunction: sortByRegion },
  ];

  const handleFilterClick = (filteredData: ScrapsCategoryInfoDTO[]) => {
    setFilteredData(filteredData);
  };

  const handleSortClick = (sortFunction: (data: ScrapsCategoryInfoDTO[]) => ScrapsCategoryInfoDTO[]) => {
    const sortedData = sortFunction([...filteredData]);
    setFilteredData(sortedData);
  };

  const fetchScrapCategories = async () => {
    try {
      const data = await getScrapCategoriesApproved();
      setScrapCategories(data);
      setFilteredData(data);
    } catch (error) {
      console.error("Error fetching scrap categories: ", error);
    }
  };

  useEffect(() => {
    fetchScrapCategories();
  }, []);

  const handleCloseModal = () => {
    fetchScrapCategories();
  };

  if (enabledUsers.includes(profile || "public")) {
    return (
      <div className="page">
        <div className="flex-row">
          <button
            className="blue-with-icon button"
            onClick={() => {
              navigate("/scrap-categories-form");
            }}
          >
            <img src={addIcon} alt="add icon" />
            <p>{t("label-add-new")}</p>
          </button>
          <ImportExportCsv
            exportApi="exportscrapbygeneratorscsv"
            importApi=""
            onClose={handleCloseModal}
          />
          <FilterComponent
            data={scrapCategories}
            onFilterClick={handleFilterClick}
            sortOptions={sortOptions}
          
          />
        </div>
        <CardListScrapCategories scrapCategories={filteredData} />
      </div>
    );
  } else {
    navigate("/page-not-found");
    return <></>;
  }
};

export default ScrapCategories;
